export const triggerGlitter = ({
  emojis = ["✨", "⭐", "🌟"],
  count = 50,
  duration = 2000,
}) => {
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.top = "0";
  container.style.left = "0";
  container.style.width = "100%";
  container.style.height = "100%";
  container.style.pointerEvents = "none";
  container.style.zIndex = "9999";
  document.body.appendChild(container);

  for (let i = 0; i < count; i++) {
    const el = document.createElement("div");
    el.textContent = emojis[Math.floor(Math.random() * emojis.length)];
    el.className = "glitter-particle";
    el.style.left = Math.random() * 100 + "vw";
    el.style.fontSize = Math.random() * 1.5 + 0.5 + "rem";
    el.style.animationDuration = Math.random() * 1 + 1 + "s";
    container.appendChild(el);
  }

  setTimeout(() => {
    document.body.removeChild(container);
  }, duration);
};
